// TeamSwitcher.jsx
import React, { useState } from 'react';

const TeamSwitcher = ({ 
  teams, 
  currentTeamId, 
  currentTeam, 
  onTeamSwitch, 
  showCreateOption, 
  integrated = false 
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedTeam = teams.find(t => t.teamId === currentTeamId);
  const ownedTeam = teams.find(t => t.isOwner);

  const getDisplayText = () => {
    if (currentTeamId === 'create' && showCreateOption) {
      return 'My Team (Create)';
    }
    if (selectedTeam) {
      return selectedTeam.isOwner 
        ? `My Team (${selectedTeam.name})` 
        : `${selectedTeam.name} (${selectedTeam.role.name})`;
    }
    if (currentTeam && integrated) {
      return currentTeam.name;
    }
    return 'Select Team';
  };

  const handleTeamSelect = (teamId) => {
    onTeamSwitch(teamId);
    setIsOpen(false);
  };

  const handleCreateTeamSelect = () => {
    if (ownedTeam) {
      handleTeamSelect(ownedTeam.teamId);
    } else {
      handleTeamSelect('create');
    }
  };

  const renderDropdownItems = () => (
    <>
      {/* My Team Option */}
      <div 
        className="dropdown-item"
        onClick={handleCreateTeamSelect}
      >
        <span>👤</span>
        <span>
          My Team {ownedTeam ? `(${ownedTeam.name})` : '(Create)'}
          {ownedTeam && <span className="role-indicator"> • Owner</span>}
        </span>
      </div>
      
      {/* Other Teams */}
      {teams.filter(t => !t.isOwner).map(team => (
        <div 
          key={team.teamId}
          className="dropdown-item"
          onClick={() => handleTeamSelect(team.teamId)}
        >
          <span>👥</span>
          <span>
            {team.name}
            <span className="role-indicator"> • {team.role.name}</span>
          </span>
        </div>
      ))}
    </>
  );

  if (integrated) {
    // Integrated mode - looks like a heading with dropdown
    return (
      <div className={`team-switcher integrated ${isOpen ? 'open' : ''}`}>
        <button 
          className="team-switcher-button"
          onClick={() => setIsOpen(!isOpen)}
        >
          {getDisplayText()}
          <i className="fas fa-chevron-down" style={{fontSize: '14px', color: '#64748b'}}></i>
        </button>
        
        {isOpen && (
          <div className="team-switcher-dropdown">
            {renderDropdownItems()}
          </div>
        )}
      </div>
    );
  }

  // Regular mode - standalone team switcher
  return (
    <div className="team-switcher">
      <button 
        className="team-switcher-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {getDisplayText()}
        <i className="fas fa-chevron-down" style={{fontSize: '14px', color: '#64748b'}}></i>
      </button>
      
      {isOpen && (
        <div className="team-switcher-dropdown">
          {renderDropdownItems()}
        </div>
      )}
    </div>
  );
};

export default TeamSwitcher;